import { useEffect, useState } from "react";
import { getTheme, subscribeTheme, type Theme } from "../libs/theme";

export function useTheme(): Theme {
  const [theme, setTheme] = useState<Theme>(getTheme);
  useEffect(() => subscribeTheme(setTheme), []);
  return theme;
}
